import * as React from 'react';

import {StackLegacy} from '../layout/stack/stack-legacy';
import {LeadCardBasic} from '../lead-card/lead-card-basic';
import type {Lead} from '../timeline/types';

type Props = {
    leads: Lead[];
};

export function PopoverContent(props: Props) {
    return (
        <div className='pad-8'>
            <StackLegacy spacing={8}>
                {props.leads.map((lead) => (
                    <LeadCardBasic
                        key={lead.id}
                        id={lead.id}
                        htmlUrl={lead.htmlUrl}
                        leadName={lead.name}
                        leadNumber={String(lead.number)}
                        avatarUrl={lead.avatarUrl}
                        relatedPerson={null}
                        relatedCompany={null}
                        value={String(lead.value && lead.value.formatted)}
                        assignee={{
                            id: (lead.assignee && lead.assignee.id) || '',
                            name: (lead.assignee && lead.assignee.name) || '',
                            type: '',
                        }}
                        openLinkInNewTab={true}
                        showRelatedEntities={false}
                    />
                ))}
            </StackLegacy>
        </div>
    );
}
